import {
  LOGIN_USER_SUCCESS,
  SET_VIEW,
  LOGOUT_USER,
  SET_PLAYBACK_DATE,
  SET_PLAYBACK_CAMERA,
  SET_PLAYBACK_TAGS,
  SET_PLAYBACK_STARTTIME,
  SET_PLAYBACK_ENDTIME,
  GET_PLAYBACK_EVENTS_START,
  GET_PLAYBACK_EVENTS_SUCCESS,
  GET_PLAYBACK_EVENTS_FAIL,
  SET_FILTERED_EVENTS,
  SET_PLAYBACK_SCROLLER_OBJ,
  SET_SELECTED_EVENT,
  SET_EVENT_CACHE,
  FLAG_EVENT_FOR_EXPORT,
  SET_SELECTED_VIDEO_PLAYING,
  SET_SELECTED_VIDEO_PLAYING_URL,
  GET_EVENT_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  date: '', // this will be initialized to today's date when user logs in
  camera: '0', // initially, no camera selected
  eventTags: [], // search all at first
  startTime: '000000', // initial search will start from 12am to 4am
  endTime: '060000', // initial search will start from 12am to 4am
  eventsLoading: false, // will be true once we call the API, and reset to false once we are done processing
  searchFilters: {}, // this will contain the last searched filters, since the other states gets updated as soon as user selects a value
  events: [], // this will contain all events received from backend
  filteredEvents: [], // this will contain events filtered by tags
  scrollerObj: '', // since timeline and cards scroll dependently with each other, we need to determine which one was scrolled by the user, so we only need to update the other
  selectedEvent: {}, // this will contain the event that was selected from the timeline, so it pulls the card in the cards container
  selectedVideoPlaying: {}, // playback event that is being played in the player
  selectedVideoPlayingUrl: '', // url of the video to be played in the player
};

// eslint-disable-next-line
export default ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
    case LOGIN_USER_SUCCESS:
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const today = `${year}-${month}-${day}`

      return {
        ...state,
        date: today,
      }
    case SET_VIEW:
      if(action.payload !== 'playback'){
        return {
          ...state,
          selectedEvent: {},
          selectedVideoPlaying: {},
          selectedVideoPlayingUrl: '',
        }
      } else {
        return {
          ...state
        }
      }
    case LOGOUT_USER:
      return INITIAL_STATE
    case SET_PLAYBACK_DATE:
      return {
        ...state,
        date: action.payload
      }
    case SET_PLAYBACK_CAMERA:
      return {
        ...state,
        camera: action.payload
      }
    case SET_PLAYBACK_TAGS:
      return {
        ...state,
        eventTags: action.payload
      }
    case SET_PLAYBACK_STARTTIME:
      return {
        ...state,
        startTime: action.payload
      }
    case SET_PLAYBACK_ENDTIME:
      return {
        ...state,
        endTime: action.payload
      }
    case GET_PLAYBACK_EVENTS_START:
      let payload = {searchFilters: action.searchFilters}
      if (action.newSearch) {
        payload.events = []
        payload.filteredEvents = []
      }
      return {
        ...state,
        ...payload,
        eventsLoading: true,
        scrollerObj: '',
        selectedEvent: {},
        selectedVideoPlaying: {},
        selectedVideoPlayingUrl: '',
      }
    case GET_PLAYBACK_EVENTS_SUCCESS:
      return {
        ...state,
        eventsLoading: false,
        events: action.events,
        filteredEvents: action.filteredEvents,
      }
    case GET_PLAYBACK_EVENTS_FAIL:
      return {
        ...state,
        eventsLoading: false,
        events: [],
        filteredEvents: [],
      }
    case SET_FILTERED_EVENTS:
      return {
        ...state,
        searchFilters: action.searchFilters,
        filteredEvents: action.filteredEvents,
      }
    case SET_PLAYBACK_SCROLLER_OBJ:
      return {
        ...state,
        scrollerObj: action.payload,
      }
    case SET_SELECTED_EVENT:
      return {
        ...state,
        scrollerObj: '',
        selectedEvent: action.payload,
      }
    case SET_EVENT_CACHE:
      return {
        ...state,
        events: action.events,
        filteredEvents: action.filteredEvents,
      }
    case FLAG_EVENT_FOR_EXPORT:
      return {
        ...state,
        events: action.events,
        filteredEvents: action.filteredEvents,
      }
    case SET_SELECTED_VIDEO_PLAYING:
      return {
        ...state,
        selectedVideoPlaying: action.payload,
      }
    case SET_SELECTED_VIDEO_PLAYING_URL:
      return {
        ...state,
        selectedVideoPlayingUrl: action.payload,
      }

    // unused functions but keeping in case it will be used in the future
    case GET_EVENT_SUCCESS:
      return {
        ...state,
        events: action.events,
        eventsLoading: false
      }
    default:
      return state;
  };
};